import styled from "styled-components";
export const Menu = styled.div `
  background-color: white;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 4px;
`;
export const Item = styled.button `
  background-color: ${({ $isSelected }) => $isSelected ? "#DBE4FC" : "#F3F5FD"};
  border: 1px solid;
  border-color: ${({ $isSelected, theme }) => $isSelected ? theme.color.s1 : "#DBE4FC"};
  border-radius: 8px;
  cursor: pointer;
  display: block;
  height: 40px;
  padding: 4px;
  width: 40px;
  &:hover {
    background-color: #dbe4fc;
    filter: brightness(1.05);
  }
`;
export const ItemImage = styled.img `
  width: 100%;
  height: 100%;
`;
